import { getApiBaseUrl } from './environment';
import { getAuthHeaders } from './auth';

/**
 * Centralized fetch wrapper that prepends the API base URL and
 * injects auth headers automatically.
 */
export async function apiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const url = `${getApiBaseUrl()}${path}`;

  const headers: Record<string, string> = {
    ...getAuthHeaders(),
    ...(options.headers as Record<string, string> | undefined),
  };

  // Set Content-Type for non-FormData bodies
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = headers['Content-Type'] ?? 'application/json';
  }

  try {
    return await fetch(url, { ...options, headers });
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown network error';
    throw new Error(`Network request failed for ${path}: ${message}`);
  }
}
